var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.lunbotuList),function(item){return _c('mt-swipe-item',{key:item.img},[_c('img',{class:{'full':_vm.isfull},attrs:{"src":item.img}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-064f4969","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/subcoment/swiper.vue
// module id = /LFa
// module chunks = 1